module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_nara-69c7ee7b07fd2c5a24be8df6c6d9c913.jpg";